import React from 'react';
import PropTypes from 'prop-types';

import {
  Grid,
  Typography,
}                                 from '@material-ui/core';

import { makeStyles }             from '@material-ui/core/styles';

import {
  TrendingDown as TrendingDownIcon,
  TrendingFlat as TrendingFlatIcon,
  TrendingUp as TrendingUpIcon,
}                                 from '@material-ui/icons';

import { 
  fmtBytes,
  fmtMetricInteger,
}                                 from '../../utils/formatters';

const useStyles = makeStyles({
  root: {
    minWidth: 170,
  },
  trendPerDay: {
    display: "flex",
    float: "right"
  },
});

export function getSizeComparator(order) {
    return(
      ({ data: data1 }, { data: data2 }) => 
        (data1.Value - data2.Value) * (order === 'asc' ? 1 : -1)
    );
}

export function getSizeTrendComparator(order) {
    return(
      ({ data: data1 }, { data: data2 }) => 
        (data1.Trend - data2.Trend) * (order === 'asc' ? 1 : -1)
    );
}

function StorageTrendIcon(props) {
  
  const { value } = props;
  
  if(value>0) {
    return(<TrendingUpIcon/>);
  } else if(value<0) {
    return(<TrendingDownIcon/>);
  } else {
    return(<TrendingFlatIcon/>);
  }
}

StorageTrendIcon.propTypes = {
  value: PropTypes.number.isRequired,
};

export function StorageBytes(props) {
  
  const { size } = props;

  if(isNaN(size)) {
    return(null);
  } else {
    let sizeText=fmtBytes(size,0);
    let sizeUnits=sizeText?sizeText.split(' ')[1]:"?";

    return(
      <Typography variant='body2' noWrap>{sizeText}{sizeUnits.length<2?<span>&nbsp;&nbsp;&nbsp;</span>:null}</Typography>
    );
  } 
}

export function StorageBytesPerDay(props) {
  
  const { trend } = props;
  const classes = useStyles();

  if(isNaN(trend)) {
    return(null);
  } else {
    const trendText=fmtBytes(trend,0);
    return(
      <div className={classes.trendPerDay}>
        <Typography variant='body2' noWrap>{trendText}/d</Typography>
        <StorageTrendIcon value={trend} fontSize='small'/>
      </div>
    );
  } 
}

export function StorageObjects(props) {
  
  const { count } = props;

  if(isNaN(count)) {
    return(null);
  } else {
    const countText=fmtMetricInteger(count);
    return(
      <Typography variant='body2' noWrap>{countText}</Typography>
    );
  } 
}

export function StorageObjectsPerDay(props) {
  
  const { trend } = props;
  const classes = useStyles();

  if(isNaN(trend)) {
    return(null);
  } else {
    const trendText=fmtMetricInteger(trend);
    
    return(
      <div className={classes.trendPerDay}>
        <Typography variant='body2' noWrap>{trendText}/d</Typography>
        <StorageTrendIcon value={trend} fontSize='small'/>
      </div>
    );
  } 
}


export default function StorageMetrics(props) {
  
  const { size, trend } = props;
  const classes = useStyles();

  if(isNaN(size)) {
    return(null);
  } else {
    const sizeText=fmtBytes(size,0);
    const sizeVal=sizeText?sizeText.split(' ')[0]:null;
    const sizeUnits=sizeText?sizeText.split(' ')[1]:null;
    const trendText=isNaN(trend)?null:fmtBytes(trend,0);
    
    return(
      <Grid container spacing={0} className={classes.root}>
        <Grid item container justify='flex-end' alignItems='center' xs={3}>
          <Typography variant='body2'>{sizeVal}</Typography>
        </Grid>
        <Grid item container justify='flex-start' alignItems='center' xs={2}>
          <Typography variant='body2'>&nbsp;{sizeUnits}</Typography>
        </Grid>
        { size===0 || isNaN(trend) ?
          <Grid item xs={6}/>:
          <Grid item container justify='flex-end' alignItems='center' xs={7} wrap='nowrap'>
            <Typography variant='body2' noWrap>{trendText}/d</Typography>
            <StorageTrendIcon value={trend} fontSize='small'/>
          </Grid>
        }
      </Grid>
    );
  } 
}

StorageMetrics.propTypes = {
  size: PropTypes.number,
  trend: PropTypes.number,
};

